import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import Modal from "../../../../components/modal/Modal";

const ModalCalendarSchedules = ({ visible, setVisible, schedules }) => {
  const events = schedules?.map((schedule) => {
    return {
      title: schedule.content.cli.name,
      start: schedule.schedule_date,
    };
  });

  return (
    <Modal
      dynamicTitle="Agendamentos"
      visible={visible}
      dynamicWidth={window.innerWidth <= 992 ? "95vw" : "70vw"}
      onHide={() => setVisible(false)}
    >
      {visible && (
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin]}
          initialView="dayGridMonth"
          events={events}
          locale={ptBrLocale}
          buttonText={{
            today: "Hoje",
            month: "Mês",
            week: "Semana",
            day: "Dia",
          }}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
        />
      )}
    </Modal>
  );
};

export default ModalCalendarSchedules;
